<template>
  <div id="app">
    <!-- preloader / spiner -->
    <div id ="preloader" :class="['preloader', this._isLoading ? 'active' :'']" >
      <div class="h-100 w-100 d-flex justify-content-center mb-3 text-center">
        <div class='wraper p-4'>
          <div class='pb-2'>
            <span>Loading ...</span>
          </div>
          <b-spinner :show="this._isLoading"></b-spinner>
        </div>
      </div>
    </div>
    <component :is="layout">
      <router-view :key="$route.fullPath" />
    </component>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
const defaultLayout = 'ControlPanel'

export default {
  ...mapGetters({
    isLoading: 'isLoading',
    getAddress: 'getAddress',
    getOptionsAuthWallet: 'auth/getOptionsAuthWallet',
    walletIsInstalled: 'walletIsInstalled'
  }),
  computed: {
    layout () { return (this.$route.meta.layout || defaultLayout) + '-layout' },
    _isLoading () { return this.$store.getters.isLoading },
    GetAddress () { return this.getAddress }
  },
  data () {
    return {
      action: '',
      ciclo: null
    }
  },
  methods: {
    init () {
      this.$store.dispatch('connectWallet')
        .then(() => {
          if (localStorage.LOGGED_IN && localStorage.ADDRESS) {
            if (Number(localStorage.LOGGED_IN) === this.$store.getters['auth/getOptionsAuthWallet'].LOGGED_IN &&
              localStorage.ADDRESS === this.$store.getters.getAddress &&
              (this.$store.getters.getAddress !== '')
            ) {
              this.$store.commit('auth/setStatusAuthWallet', this.$store.getters['auth/getOptionsAuthWallet'].LOGGED_IN)
            } else {
              localStorage.ADDRESS = ''
              localStorage.LOGGED_IN = this.$store.getters['auth/getOptionsAuthWallet'].NOT_LOGGED_IN
              this.$store.commit('auth/setStatusAuthWallet', this.$store.getters['auth/getOptionsAuthWallet'].NOT_LOGGED_IN)
            }
          } else {
            this.$store.dispatch('auth/logoutWallet')
          }
        })
    }
  },
  created () {
    this.init()
    const vm = this
    window.addEventListener('message', async function (e) {
      // Tronlink chrome v3.22.0 & Tronlink APP v4.3.4 started to support
      if (e.data.message && (e.data.message.action === 'accountsChanged' ||
        e.data.message.action === 'setNode')
      ) {
        console.log('e.data.message.action', e.data.message.action)
        console.log('current address:', e.data.message.data.address)
        console.log('ciclo: ', vm.ciclo)
        vm.action = await e.data.message.action
        if (vm.ciclo === null) {
          vm.ciclo = -1
          vm.$store.commit('setLoading', true)
          let count = 1
          vm.ciclo = setInterval(() => {
            console.log('count', count)
            if (count === 2) {
              console.log('action', vm.action)
              clearInterval(vm.ciclo)
              vm.ciclo = null
              vm.$store.dispatch('reset')
              vm.init()
            }
            count++
          }, 500)
        }
      }
    })
  },
  updated () {}
}
</script>

<style>
/*fuentes*/
@font-face{
  font-family: "Poppins-Bold";
  src:
    local("Poppins-Bold"),
    url('~@/assets/fonts/poppins/Poppins-Bold.ttf')format('truetype');
}
@font-face{
  font-family: "Poppins-Light";
  src:
    local("Poppins-Light"),
    url('~@/assets/fonts/poppins/Poppins-Light.ttf')format('truetype');
}
.preloader {
  display: none;
  position: absolute;
  top: 0px; width: 100%;
  height: 100%;
  z-index: 9999;
  background-color: #0000003d;
}
.preloader.active {
  display: flex;
}
.preloader .wraper{
  margin: auto;
  background-color: #393939ff;
  border-radius: 10px;
  color: #fedc57ff;
}

/* bordes rendondeados*/
form input,
.modal-content {
  border-radius: 10px !important;
}
form input {
  color: #A7A4A4 !important;
  -webkit-text-fill-color: #A7A4A4;
  font-family:  "Poppins-Light";
  clip: auto;
  background-color: #393939ff !important;
  border: 1px solid #393939ff !important;
}
.btn-primary,
.btn-primary:hover,
.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active
{
  font-family: 'Poppins-Light';
  font-style: normal;
  font-weight: normal;
  color: #808080ff !important;
  background-color: #fedc57ff !important;
  border: 1px solid #fedc57ff !important;
  border-radius: 10px !important;
}

.btn-primary:focus {
  /*efecto*/
  outline: 0;
  box-shadow: 0 0 0 0.15rem #f4c96cb5 !important;
}
.btn-secondary,
.btn-secondary:hover,
.btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled).active
{
  font-family: 'Poppins-Light';
  font-style: normal;
  font-weight: normal;
  color: #A7A9AC !important;
  background-color: #414042 !important;
  border: 1px solid #414042 !important;
  border-radius: 10px !important;
}

.modal-content {
  background-color: #282828 !important;
  color: #ffff;
  max-width: 420px;
  margin: auto;
}
#connect-to-wallet-id .modal-content .modal-body{
  padding-left: 6px;
  padding-right: 6px;
}
.modal-content .header,
.modal-header {
  font-family: "Poppins-Light";
  font-style: normal;
  font-weight: 600 !important;
  text-align: center;
  color: #f4c96cff;
  border-bottom: 0px solid #dee2e6 !important;
}
.modal-content .header{
  margin-top: 24px;
  margin-bottom: 6px;
}
.modal-header .close {
  color: #fff;
}
.modal-footer {
  border-top: 0px solid #dee2e6 !important;
}
#connect-to-wallet-id .modal-content .body p,
#connect-to-wallet-id .modal-content .body h6 {
  font-family: "Poppins-Light";
  font-style: normal;
  color: #A7A4A4 !important;
  font-size: 15px;
}
#connect-to-wallet-id .modal-content .body h6 {
  color: #f4c96cff !important;
}
#connect-to-wallet-id .modal-content .body .wraper {
  width: 200px;
  margin: auto;
  text-align: center;
  border-bottom: 0.1px solid #8b8888;
}
#connect-to-wallet-id .modal-content .body .wraper img {
  width: 45px;
  border-radius: 10px;
}
#connect-to-wallet-id .body form {
  min-height: 130px;
}

.main{
  position: relative;
  display: table;
  width: 100%;
  height: 100%;
}
.main .container .wraper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.main .container .wraper img {
  width: 250px;
  /* height: 250px; */
}

.main .container h2 { color: #fff; }
.main .container h2 b { color: #f9b707;}
.main .container p { color: #e3e3e3; }

.main .container ::selection {
  background: #f9b707;
  color: #fff;
  text-shadow: none;
}

.main:before {
    position: absolute;
    top: 0%;
    left: 0%;
    content: "";
    width: 100%;
    height: 100%;
    display: inline-block;
    background-image: url(assets/02.jpg);
}

@media (min-width: 768px) {
  .main {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.img-default {
  width: 100px;
  height: 100px;
  background-color: #fff;
}
/* form presale, stake-team */
form .group.buy,
.stake form .box,
.profile .box {
  background-color: #393939;
  border-radius: 12px;
  padding: 12px 20px 8px 20px;
}

.profile .box {
  padding: 4px 20px 4px 20px;
}
form .group.buy input {
  padding-left: 0px;
}

.stake .color-primary,
.profile .color-primary {
  color: #F4C96C !important;
}
.stake .color-secondary,
.profile .color-primary {
  color: #FFFFFF;
}
.stake .box .icon{
  background-color: #F4C96C !important;
}
.stake .box .icon{
  display: table;
  height: 37px;
  width: 37px;
  margin: auto;
  border-radius: 25px;
}
.stake .box .icon .wraper{
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.stake .input-group-text{
  color: #282828 !important;
}
.stake .input-group input {
  margin-left: -16px;
  padding-left: 28px;
  z-index: 0 !important;
}
.stake form input{
color: #FFFFFF !important;
-webkit-text-fill-color: #FFFFFF;
}
.stake form .input-group-text{
  color: #FFFFFF;
  background: none;
  border: none;
}
.stake form .form-control,
.stake form .form-control.is-valid,
.stake .form-control.is-valid:focus,
.stake form .form-control.is-invalid{
  /*base*/
  background-image:none;
  border: 0px solid #FFFFFF !important;
  outline: 0;
  -webkit-box-shadow: 0 0 0 0 #ffff !important;
  box-shadow: 0 0 0 0 #ffff !important;
}
.stake .btn-primary,
.stake .btn-primary:hover,
.stake .btn-primary:not(:disabled):not(.disabled):active,
.stake .btn-primary:not(:disabled):not(.disabled).active
{
  font-weight: bold !important;
  color: #282828 !important;
  background-color: #F4C96C !important;
  border: 1px solid #F4C96C !important;
}

/* pie-chart */
.stake .pie-chart{
    margin-bottom: 26px;
    width: 200px;
    height: 220px;
    margin: auto;
}
.stake .pie-chart .icon-circle {
    display: table;
    height: 200px;
    width: 200px;
    position: absolute;
}
.stake .pie-chart .icon-circle .icon{
    display: table-cell;
    vertical-align: middle;
    text-align: center;
}
.stake .pie-chart .icon-circle .icon .wraper{
    height: 100px;
    width: 100px;
    margin: auto;
    border-radius: 50%;
    background-color: #2E2E2E !important;
}
.stake a {
  color: #A7A4A4;
}
.stake a:hover,
.stake a:focus {
  color: #F4C96C !important;
  -webkit-transition: all 50ms ease-in-out 0s;
  -moz-transition: all 50ms ease-in-out 0s;
  -ms-transition: all 50ms ease-in-out 0s;
  -o-transition: all 50ms ease-in-out 0s;
  transition: all 50ms ease-in-out 0s;
  text-decoration: none;
  cursor: pointer;
}
.stake.main{
    position: relative;
    display: table;
    width: 100%;
    height: 100%;
}
</style>
